<template>
    <div class="fit-to-content">
        <Select v-model="level" placeholder="Select Level" clearable @on-change="getServerLogList(1)" style="width: 200px;margin-bottom: 24px;">
            <Option value="info">INFO</Option>
            <Option value="warn">WARNING</Option>
            <Option value="error">ERROR</Option>
        </Select>
        <Table :columns="columns" :loading="dataLoading" :data="serverlogs" :row-class-name="LogRowClassName" width="1080">
            <div slot-scope="{ row, index }" slot="status">
                <p>{{row.meta.Status}}</p>
            </div>
            <div slot-scope="{ row, index }" slot="account">
                <span v-if="row.meta.Account.MailAddress">{{row.meta.Account.MailAddress}}</span>
                <span v-else>{{row.meta.Ip}}</span>
            </div>
            <div slot-scope="{ row, index }" slot="role">
                <p>{{row.meta.Account.role}}</p>
            </div>
            <div slot-scope="{ row, index }" slot="info">
                <Icon type="md-information-circle"
                      size="24"
                      @click.native="showInfo(row)"
                      class="cursor-pointer"/>
            </div>
        </Table>
        <Page ref="paginator" :total="dataCount" show-sizer  @on-change="pageChanged" @on-page-size-change="pageSizeChanged" class="right" style="margin-top: 16px;"/>
        <ServerLogInfoModal ref="serverLogInfoModal"></ServerLogInfoModal>
    </div>
</template>

<script>
    import ServerLogInfoModal from './LogInfoModal'
    import { bus } from "../../main";
    import { getServerLogs } from "../../_services/sessions.service";

    export default {
        components:{
            ServerLogInfoModal
        },
        data() {
            return {
                columns: [
                    {
                        title: "Time",
                        key: "timestamp",
                        sortable: true,
                        width:210
                    },
                    {
                        title: "Level",
                        key: "level",
                        width:80,
                        align:'center'
                    },
                    {
                        title: "Status",
                        slot: "status",
                        width:80,
                        align:'center'
                    },
                    {
                        title: "Description",
                        key: "message",
                        className:"col-ellipsis",
                        width:300,
                    },
                    {
                        title: "Account",
                        slot: "account",
                        width:220,
                        className:"col-ellipsis"
                    },

                    {
                        title: "Role",
                        slot: "role",
                    },
                    {
                        title: " ",
                        width:50,
                        slot: "info",
                        align:"right"
                    }

                ],
                level:"",
                dataCount:10,
                currentPage:1,
                rowSize:10,
                serverlogs: [],
                dataLoading:true
            };
        },
        methods: {
            getServerLogList(page) {
                if(page){
                    this.$refs.paginator.changePage(page)
                    this.currentPage=page
                }
                this.dataLoading=true
                let offset = 0
                if(this.currentPage>1){
                    offset = (this.currentPage-1)*this.rowSize
                }
                let params={Offset:offset,MaxResults:this.rowSize,Level:this.level}
                getServerLogs(params).then(res => {
                    this.serverlogs = res.data.data.rows;
                    this.dataCount = res.data.data.total[0].count;
                    this.dataLoading = false
                }).catch(err => {
                    this.dataLoading = false
                    bus.$emit('requestError',err)
                    this.$Message.error("Failed to get server logs. Please try again later.");
                });
            },
            pageChanged(val){
                this.currentPage=val
                this.getServerLogList()
            },
            pageSizeChanged(val){
                this.rowSize=val
                this.getServerLogList()
            },
            showInfo(data){
                this.$refs.serverLogInfoModal.triggerModal(data)
            },
            LogRowClassName(row, index) {
                if (row.level === 'error') {
                    return 'error-table-row';
                }
                return '';
            },
        },
        mounted() {
            this.getServerLogList();
        }
    };
</script>
<style scoped>
    .remove-all{
        margin-top: 20px;
        float: right;
    }
</style>
<style>
    .col-ellipsis .ivu-table-cell span{
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }
</style>
